import { render, staticRenderFns } from "./SaleProduct.vue?vue&type=template&id=cf4e2558&"
import script from "./SaleProduct.vue?vue&type=script&lang=js&"
export * from "./SaleProduct.vue?vue&type=script&lang=js&"
import style0 from "./SaleProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports